// apps/storefront/src/components/CookiePrefsLink.tsx
'use client'
import { OPEN_PREFS_EVENT } from '@/lib/consent'

export function CookiePrefsLink({ className }: { className?: string }) {
  return (
    <button
      type="button"
      // A <button> keeps the arrow cursor by default; it reads as a link here,
      // so it gets the hand like the <a> links beside it.
      className={`cursor-pointer ${className ?? 'underline opacity-80 hover:opacity-100'}`}
      onClick={() => window.dispatchEvent(new Event(OPEN_PREFS_EVENT))}
    >
      Your Privacy Choices
    </button>
  )
}
